import React, { useEffect, useState } from "react";

// Chakra imports
import {
  Box,
  Button,
  Flex,
  Link,
  Text,
  useColorModeValue,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Stack,
  Alert,
  AlertIcon,
  IconButton,
  SimpleGrid
} from "@chakra-ui/react";

// Custom components
import HistoryItem from "views/admin/Detected Product/components/HistoryItem";
import SuspiciousItem from "views/admin/Detected Product/components/SuspiciousItem";
import WhitelistedProduct from "views/admin/Detected Product/components/WhitelistedProduct";
import { SearchBar } from "components/navbar/searchBar/SearchBar";
import { MdViewList, MdViewModule, MdCheckCircle, MdCancel, MdDelete, MdShoppingCart, MdOutlineError } from "react-icons/md";

import Card from "components/card/Card.js";
import { useListContext } from "../../../contexts/listContext";
import { useProductStore } from "../../../store/useProductStore"
import useRelevanceChanges from "hooks/useRelevanceChanges";

import Loader from "../../../components/loader/Loader";

export default function Products() {
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  // Chakra Color Mode
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const userInfo = JSON.parse(localStorage.getItem("PAuser"));
  const [productsToShow, setProductsToShow] = useState(20);
  const productsPerPage = 20;

  const isAdmin = userInfo?.message?.isAdmin || false;


  const [insertSeller, setInsertSeller] = useState([]);
  const [deleteList, setDeleteList] = useState([]);
  const [statusUpdate, setStatusUpdate] = useState(false);
  const { list, checkedPlatforms, dateFilter, abuse_type } = useListContext();
  const [keywordOptions, setKeywordOptions] = useState([]);
  const [sortedProducts, setSortedProducts] = useState([]);

  const [successAlert, setSuccesAlert] = useState("");
  const [failureAlert, setFailureAlert] = useState("");
  const [alertTimeout, setAlertTimeout] = useState(null);
  const [isLoading, setIsLoading] = useState(false)
  const [viewMode, setViewMode] = useState("grid")


  const [noAbuseProducts, setNoAbuseProducts] = useState([]);
  const [abuseCulprit, setAbuseCulprit] = useState([]);


  const {
    products,
    moveProducts,
    updateProducts,
  } = useProductStore();
  
  const {
    relevanceChanges,
    handleInsertRelevance,
    clearRelevanceChanges
  } = useRelevanceChanges();



  useEffect(() => {
    return () => {
      if (alertTimeout) {
        clearTimeout(alertTimeout);
      }
    };
  }, [alertTimeout]);

  const handleSuccessAlert = async (alertMessage) => {
    if (alertTimeout) {
      clearTimeout(alertTimeout);
    }
    setSuccesAlert(alertMessage);
    const timeout = setTimeout(() => {
      setSuccesAlert("");
    }, 5000);
    setAlertTimeout(timeout);
  };

  const handleFailureAlert = async (alertMessage) => {
    if (alertTimeout) {
      clearTimeout(alertTimeout);
    }
    setFailureAlert(alertMessage);
    const timeout = setTimeout(() => {
      setFailureAlert("");
    }, 5000);
    setAlertTimeout(timeout);
  };

  const fetchProductsByStatus = async (status) => {
    try {
      setIsLoading(true)
      const response = await fetch(
        `${backendUrl}/api/products/byStatus`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            uid: userInfo?.message?.result.id,
            status: status,
          }),
        }
      );

      const json = await response.json();

      if (response.ok) {
        updateProducts(json, "whitelisted");
      } else if (response.status === 400) {
        handleFailureAlert("Error in fetching products");
      }
      setIsLoading(false)
    } catch (e) {
      setIsLoading(false)

      handleFailureAlert("Error in fetching products");
    }
  };

  const loadMore = () => {
    setProductsToShow(productsToShow + productsPerPage);
  };

  const loadLess = () => {
    setProductsToShow(productsToShow - productsPerPage);
  };

  const fetchProducts = async () => {
    try {
      setIsLoading(true)

      const response = await fetch(`${backendUrl}/api/products/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          uid: userInfo?.message?.result.id,
        }),
      });

      const json = await response.json();

      if (response.ok) {
        setIsLoading(false)
        updateProducts(json, "detected");
        return json;
      } else if (response.status === 400) {
        setIsLoading(false)
        handleFailureAlert("An error occurred");
      }

    } catch (e) {
      setIsLoading(false)

      handleFailureAlert("An error occurred");
    }
  };

  useEffect(() => {
    if (!products["detected"]) {
      fetchProducts();
    } else {
      setSortedProducts(products["detected"]);
    }
  }, [userInfo?.message?.result.id]);

  const handleInsertSeller = async (product, seller_status) => {
    try {

      if (seller_status === "X") {
        const existingIndex = deleteList.findIndex(
          (item) => item.product.psm_id === product.psm_id
        );
        if (existingIndex !== -1) {
          setDeleteList((prev) => {
            const updatedSeller = [...prev];
            updatedSeller[existingIndex].seller_status = seller_status;
            return updatedSeller;
          });
        } else {
          setDeleteList([...deleteList, { product, seller_status }]);
        }
      } else {
        const existingIndex = insertSeller.findIndex(
          (item) => item.product.psm_id === product.psm_id
        );
        const existingIndexDeleteList = deleteList.findIndex(
          (item) => item.product.psm_id === product.psm_id
        );

        if (existingIndex !== -1) {
          setInsertSeller((prev) => {
            const updatedSeller = [...prev];
            updatedSeller[existingIndex].seller_status = seller_status;
            return updatedSeller;
          });
        } else if (existingIndexDeleteList !== 1) {
          setDeleteList(
            deleteList.filter((item) => {
              return !(item.product.psm_id === product.psm_id);
            })
          );
          setInsertSeller([...insertSeller, { product, seller_status }]);
        } else {
          setInsertSeller([...insertSeller, { product, seller_status }]);
        }
      }
    } catch (err) {
      console.error("err in handleInserSeller", err);
    }
  };

  const removeFromInsert = async (product, seller_status) => {
    if (seller_status === "X") {
      setDeleteList(
        deleteList.filter((item) => {
          return !(item.product.psm_id === product.psm_id);
        })
      );
    } else {
      setInsertSeller(
        insertSeller.filter((item) => {
          return !(item.product.psm_id === product.psm_id);
        })
      );
    }
  };


  const handleInsertAbuse = async (product, abuse_type) => {
    try {
      const existingIndex = abuseCulprit.findIndex(
        (item) => item.product.psm_id === product.psm_id
      );

      if (existingIndex !== -1) {
        setAbuseCulprit((prev) => {
          const updated = [...prev];
          updated[existingIndex].abuse_type = abuse_type;
          return updated;
        });
      } else {
        setAbuseCulprit([...abuseCulprit, { product, abuse_type }]);
      }
      // console.log("abus culprit", abuseCulprit)
    } catch (err) {
      console.error("err in handleInserAbuse", err);
    }
  };

  const handleMoveToNoAbuse = (pd_id) => {
    setSortedProducts(prev => prev.filter(prod => prod.pd_id !== pd_id));
  };

  const handleSaveChanges = async () => {
    try {
      setIsLoading(true)

      const uid = await JSON.parse(localStorage.getItem("PAuser")).message
        .result.id;

      const response = await fetch(`${backendUrl}/api/sellers/insertSeller/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          products: insertSeller,
          uid: uid,
        }),
      });

      const json = await response.json();

      if (!response.ok) {
        console.error("First API call failed:", json);
        setIsLoading(false)

        handleFailureAlert(
          `Error saving changes: ${json.message || "Unknown error"}`
        );
        return;
      }

      // Move all products from the same sellers
      for (const item of insertSeller) {
        const { product, seller_status } = item;

        const sellerProducts = products["detected"].filter(
          (p) => p.seller_name === product.seller_name
        );
        console.log(sellerProducts)

        if (seller_status === "S") {
          await moveProducts("detected", sellerProducts, "suspicious");
        } else if (seller_status === "W") {
          await moveProducts("detected", sellerProducts, "whitelisted");
        } else if (seller_status === "NR") {
          await moveProducts("detected", product, "nonReportable");
        }
      }


      // for (const item of insertSeller) {
      //   const { product, seller_status } = item;
      //   let sellerProducts=[]
      //   if (!product.seller_name?.toLowerCase().startsWith("xxxx")) {
      //     sellerProducts = products["detected"].filter(
      //       (p) => p.seller_name === product.seller_name
      //     );
      //   }else{
      //     sellerProducts = products["detected"].filter(
      //       (p) => p.pd_id === product.pd_id
      //     );
      //   }
      //     console.log(sellerProducts)

      //     if (seller_status === "S") {
      //       await moveProducts("detected", sellerProducts, "suspicious");
      //     } else if (seller_status === "W") {
      //       await moveProducts("detected", sellerProducts, "whitelisted");
      //     }
      // }


      const response1 = await fetch(
        `${backendUrl}/api/sellers/updateSellerStatus/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            sellers: deleteList,
            uid: uid,
          }),
        }
      );

      const json1 = await response1.json();

      if (!response1.ok) {
        setIsLoading(false)

        console.error("Second API call failed:", json1);
        handleFailureAlert(
          `Error saving changes: ${json1.message || "Unknown error"}`
        );
        return;
      }
      setIsLoading(false)

      // Then handle abuse reports if any exist
      // if (abuseCulprit.length > 0) {
      //   const abused = abuseCulprit.map((item) => ({
      //     psm_id: item.product.psm_id,
      //     abuse_type: item.abuse_type,
      //   }));

      //   const abuseResponse = await fetch(
      //     `${backendUrl}/api/products/reportAbuse/`,
      //     {
      //       method: "POST",
      //       headers: {
      //         "Content-Type": "application/json",
      //       },
      //       body: JSON.stringify({
      //         products: abused,
      //       }),
      //     }
      //   );

      //   if (!abuseResponse.ok) {
      //     setIsLoading(false)

      //     handleFailureAlert("Failed to save abuse reports");
      //     return;
      //   }

      //   // Handle products with abuse_type 0 (No Abuse)
      //   const noAbuseProductsList = abuseCulprit
      //     .filter((item) => parseInt(item.abuse_type) === 0)
      //     .map((item) => ({
      //       ...item.product,
      //       abuse_type_id: 0 // Update the abuse_type_id to 0
      //     }));
      //   console.log("noabuse list", noAbuseProductsList)
      //   setNoAbuseProducts((prev => [...noAbuseProductsList, ...prev]))

      //   let productsToRemove = [];

      //   if (noAbuseProductsList.length > 0) {
      //     // Add to noAbuse in store first
      //     await moveProducts("detected", noAbuseProductsList, "noAbuse");
      //     productsToRemove.push(...noAbuseProductsList.map(p => p.psm_id));

      //     // Update the products store to ensure noAbuse products are available
      //     updateProducts(noAbuseProductsList, "noAbuse");

      //     // Call handleMoveToNoAbuse for each product to update UI immediately
      //     noAbuseProductsList.forEach(product => {
      //       handleMoveToNoAbuse(product.pd_id);
      //     });
      //   }
      // }

      // Move deleted products
      for (const item of deleteList) {
        const { product } = item;
        await moveProducts("detected", product, "toDelete");
      }
      if (relevanceChanges.length > 0) {

        const relevanceResponse = await fetch(
          `${backendUrl}/api/products/updateRelevance`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              products: relevanceChanges,
            }),
          }
        );

        if (!relevanceResponse.ok) {
          handleFailureAlert("Failed to update relevance.");
          return;
        }
      }
      setDeleteList([]);
      setInsertSeller([]);
      // setAbuseCulprit([]);
      clearRelevanceChanges();      // Update UI state
      handleSuccessAlert("Changes Saved Successfully");

      // Force UI update without refetching
      setStatusUpdate((prev) => !prev);
    } catch (e) {
      setIsLoading(false)

      console.error("Error in handleSaveChanges:", e);
      handleFailureAlert(
        `Error saving changes: ${e.message || "Please try again"}`
      );
    } finally {
      setDeleteList([]);
      setInsertSeller([]);
      // setAbuseCulprit([]);
      clearRelevanceChanges();
    }
  };

  const fetchKeywordOptions = async () => {
    try {
      setIsLoading(true)

      const userInfo = JSON.parse(localStorage.getItem("PAuser"));
      const response = await fetch(
        `${backendUrl}/api/keyword/getKeywordsForFilter/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            uid: userInfo?.message?.result.id,
          }),
        }
      );

      const json = await response.json();

      if (response.ok) {
        setIsLoading(false)
        setKeywordOptions(json);
      } else if (response.status === 400) {
        setIsLoading(false)

        handleFailureAlert("Failed to fetch Keywords");
      }
    } catch (e) {
      console.error("error in getkeywords", e);
    }
  };

  useEffect(() => {
    if (!keywordOptions) {
      fetchKeywordOptions();
    }
  }, [keywordOptions]);

  const handleSearch = async (text) => {
    try {
      if (text) {
        setSortedProducts(
          products["detected"].filter(
            (item) =>
              item.title?.toLowerCase().includes(text?.toLowerCase()) ||
              item.keyword?.toLowerCase().includes(text?.toLowerCase()) ||
              item.seller_name?.toLowerCase().includes(text?.toLowerCase()) ||
              item.prod_code?.toLowerCase().includes(text?.toLowerCase())
          )
        );
      } else {
        setSortedProducts(products["detected"]);
      }
    } catch (e) {
      console.error("error in search", e);
    }
  };

  const handleFilter = async () => {
    try {
      let keywordNames = list.map((item) => item.name?.toLowerCase());
      let platformIds = checkedPlatforms.map((item) => item.id);
      let allProducts = products["detected"] || [];
      let kfilter;
      let pfilter;
      let dateSort;
      console.log("ALL", allProducts)


      kfilter = allProducts.filter((item) =>
        keywordNames.includes(item.keyword.toLowerCase())
      );
      console.log("kfilter", kfilter)

      pfilter = kfilter.filter((item) =>
        platformIds.includes(item.platform_id)
      );

      //Date Filter
      if (dateFilter.startDate && dateFilter.endDate) {
        let startDate = new Date(dateFilter.startDate);
        let endDate = new Date(dateFilter.endDate);
        endDate.setHours(23, 59, 59, 999);

        dateSort = pfilter.filter((item) => {
          let date = new Date(item.date_detected);
          return date >= startDate && date <= endDate;
        });

        setSortedProducts(dateSort);
      } else {
        setSortedProducts(pfilter)
      }
    } catch (err) {
      console.error("Error in handleFilter:", err);
    }
  };

  useEffect(() => {
    handleFilter();
  }, [list, checkedPlatforms, products["detected"], dateFilter]);

  const checkWhiteList = async () => {
    if (!products["whitelisted"]) {
      fetchProductsByStatus("W");
    }
  };

  return (
    <Tabs
      colorScheme="messenger"
      pt={{ base: "180px", md: "80px", xl: "80px" }}
    >
      <TabList>
        <Tab border="transparent">Detected</Tab>
        {/* <Tab border="transparent" onClick={() => fetchProductsByStatus("W")}> */}
        <Tab border="transparent" onClick={() => checkWhiteList()}>
          Whitelist
        </Tab>
      </TabList>
      <TabPanels>
        <TabPanel>
          <Box>
            {isLoading && <Loader />}
            <Card p="0px" w="100%">
              <Flex justify={"space-between"} m={2}>

                <Text px="20px" pt="10px">
                  Count: {sortedProducts.length}
                </Text>
                <Flex gap={2}>
                  <IconButton size="md" icon={<MdViewList />} isActive={viewMode === 'list'} onClick={() => setViewMode('list')} />
                  <IconButton size="md" icon={<MdViewModule />} isActive={viewMode === 'grid'} onClick={() => setViewMode('grid')} />

                </Flex>
              </Flex>
              <Box
                position="sticky"
                top="95px"
                zIndex="10"
                bg={useColorModeValue("white", "navy.800")} // Match your card's background
                boxShadow="sm" // Optional: adds a shadow when scrolling
                pb="10px"
                rounded={10}
              >


                <Flex
                  align={{ sm: "flex-start", lg: "center" }}
                  justify="space-between"
                  w="100%"
                  px="22px"
                  py="18px"
                >
                  <SearchBar
                    m="10px"
                    borderRadius="30px"
                    onChange={(e) => handleSearch(e.target.value)}
                  />
                  {/* {isAdmin && ( */}


                  <Button
                    variant="action"
                    alignSelf="right"
                    onClick={handleSaveChanges}
                  >
                    Save Changes
                  </Button>
                  {/* )} */}
                </Flex>
              </Box>
              <SimpleGrid columns={viewMode === 'grid' ? { base: 1, md: 3, xl: 4 } : 1} spacing={3}>

                {sortedProducts.slice(0, productsToShow).map((prod, index) => (
                  <SuspiciousItem
                    key={prod.psm_id}
                    index={index}
                    product={prod}
                    handleInsertSeller={handleInsertSeller}
                    removeFromInsert={removeFromInsert}
                    statusUpdate={statusUpdate}
                    setStatusUpdate={setStatusUpdate}
                    fetchProducts={fetchProducts}
                    handleInsertRelevance={handleInsertRelevance}
                    keywordOptions={keywordOptions}
                    moveProducts={moveProducts}
                    isAdmin={isAdmin}
                    viewMode={viewMode}
                    abuseTypes={abuse_type}
                    handleInsertAbuse={handleInsertAbuse}
                    setNoAbuseProducts={setNoAbuseProducts}
                  />
                ))}
              </SimpleGrid>
            </Card>
            <Stack spacing={3} position="fixed" right="10px" bottom="2vh">
              {successAlert !== "" && (
                <Alert status="success" variant="left-accent" w="40vw">
                  <AlertIcon />
                  {successAlert}
                </Alert>
              )}
              {failureAlert !== "" && (
                <Alert status="error" variant="left-accent" w="40vw">
                  <AlertIcon />
                  {failureAlert}
                </Alert>
              )}
            </Stack>


            <Link>
              <Text
                color={textColor}
                fontSize="l"
                fontWeight="500"
                onClick={loadLess}
                r="0"
                position="absolute"
                right={{ base: "10%", md: "15%", sm: "30%" }}
                textDecoration="underline"
              >
                Show less...
              </Text>
            </Link>
            <Link>
              <Text
                color={textColor}
                fontSize="l"
                fontWeight="500"
                onClick={loadMore}
                r="0"
                position="absolute"
                right={{ base: "2%", md: "5%" }}
                textDecoration="underline"
              >
                Show more...
              </Text>
            </Link>
          </Box>
        </TabPanel>
        <TabPanel>
          <WhitelistedProduct
            userId={userInfo?.message?.result.id}
            whitelistedProducts={products["whitelisted"] || []}
            fetchProductsByStatus={fetchProductsByStatus}
            isAdmin={isAdmin}
            isFetching={isLoading}
          />
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
}
